// DO NOT MODIFY - this file is auto-generated by build-icons.js
// @ts-nocheck
import React from 'react';
import Icon from '../shared/icon';

/* eslint-disable react/jsx-max-props-per-line,react/jsx-space-before-closing,react/jsx-tag-spacing */

const ShareIcon = (props) => (
  <Icon {...props}>
    {
      ({ color, width, height }) => (
        <svg width={width} height={height} viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
          <path fill="inherit" d="M26.9565 18.3696C26.4783 18.3696 26.087 18.7609 26.087 19.2391V26.413C26.087 27.3696 25.3044 28.1522 24.3478 28.1522H3.47826C2.52174 28.1522 1.73913 27.3696 1.73913 26.413V5.54348C1.73913 4.58696 2.52174 3.80435 3.47826 3.80435H10.6522C11.1304 3.80435 11.5217 3.41304 11.5217 2.93478C11.5217 2.45652 11.1304 2.06522 10.6522 2.06522H3.47826C1.56522 2.06522 0 3.63044 0 5.54348V26.413C0 28.3261 1.56522 29.8913 3.47826 29.8913H24.3478C26.2609 29.8913 27.8261 28.3261 27.8261 26.413V19.2391C27.8261 18.7609 27.4348 18.3696 26.9565 18.3696Z" />
          <path fill="inherit" d="M28.2609 0H19.5652C18.7174 0 18.0109 0.608696 17.8587 1.41304C17.837 1.52174 17.8261 1.63044 17.8261 1.73913C17.8261 2.69565 18.6087 3.47826 19.5652 3.47826H24.0652L11.4239 16.1196C10.75 16.7935 10.75 17.9022 11.4239 18.5761C11.7609 18.913 12.2065 19.087 12.6522 19.087C13.0978 19.087 13.5435 18.913 13.8804 18.5761L26.5217 5.93478V10.4348C26.5217 11.3913 27.3043 12.1739 28.2609 12.1739C28.337 12.1739 28.4022 12.163 28.4783 12.163C29.337 12.0544 30 11.3261 30 10.4348V1.73913C30 0.782609 29.2174 0 28.2609 0Z" />
        </svg>
      )
    }
  </Icon>
);

export default ShareIcon;
